import { Injectable, inject } from '@angular/core';
import {UrlBuilderService} from './url-builder.service';

const preloadedResources = [
  // for the moment, no resources are preloaded
];

@Injectable({
  providedIn: 'root'
})
export class ResourcePreloaderService {
  private urlBuilder = inject(UrlBuilderService);

  /** Inserted by Angular inject() migration for backwards compatibility */
  constructor(...args: unknown[]);


  constructor() {
    this.preloadResources();
  }

  private async preloadResources() {
    for (let resource of preloadedResources) {
      //console.log('Preloading resource: ', resource);
      await fetch(this.urlBuilder.buildImageUrl(resource)).catch(err => {
        console.log(`Error preloading resource: ${resource}`);
      });
    }
  }
}
